// deps
import React, { memo, useCallback, useMemo } from "react";

// internal deps
import { HorizontalScroller } from "@swiggy-private/core-ui";
import { DeliveryInstructionDetail } from "@swiggy-private/cart-types";

// constants
import {
    INSTRUCTION_ITEM_HEIGHT_UX4,
    INSTRUCTION_ITEM_WIDTH_UX4,
    INSTRUCTION_ITEM_VISIBILITY_THRESHOLD,
} from "@cart-ui/constants/DeliveryInstructionItem";

// components
import DeliveryInstructionItem from "./DeliveryInstructionItem";

import styles from "../styles/DeliveryInstruction.scss";
import classNames from "classnames";

export interface DeliveryInstructionItemCollectionProps {
    instructionArray: DeliveryInstructionDetail[];
    onItemClick: (itemType: DeliveryInstructionDetail) => void;
}

const DeliveryInstructionItemCollection: React.FC<DeliveryInstructionItemCollectionProps> = ({
    instructionArray,
    onItemClick,
}: DeliveryInstructionItemCollectionProps) => {
    const onDeliveryInstructionItemClick = useCallback(
        (item) => {
            return (event: React.MouseEvent): void => {
                event.preventDefault();
                event.stopPropagation();
                if (onItemClick) {
                    onItemClick(item);
                }
            };
        },
        [onItemClick],
    );

    const getItems = useMemo(() => {
        return instructionArray.map((instructionData) => (
            <DeliveryInstructionItem
                onDeliveryInstructionItemClick={onDeliveryInstructionItemClick(instructionData)}
                key={instructionData.id}
                data={instructionData}
            />
        ));
    }, [instructionArray, onDeliveryInstructionItemClick]);

    const instructionWrapperClass = classNames(styles.instructionWrapper, styles.instructionWrapperCartV2);

    const itemClassName = classNames(
        styles.instructionWrapperItemContainer,
        styles.instructionWrapperItemContainerCartV2,
    );

    const containerClassName = classNames(
        styles.instructionWrapperScrollBarContainer,
        styles.instructionWrapperScrollBarContainerCartV2,
    );

    return (
        <div className={instructionWrapperClass}>
            <HorizontalScroller
                containerClassName={containerClassName}
                itemClassName={itemClassName}
                items={getItems}
                height={INSTRUCTION_ITEM_HEIGHT_UX4}
                itemVisibilityThreshold={INSTRUCTION_ITEM_VISIBILITY_THRESHOLD}
                width={INSTRUCTION_ITEM_WIDTH_UX4}
            />
        </div>
    );
};

export default memo(DeliveryInstructionItemCollection);
